import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseOperationUpdatedTemplates = [
  {
    id: '-218001',
    language: Language.EN,
    subject: 'Exceptional charge or service update',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>An exceptional charge or service has been updated.</p>
          <p>More details here: {{pdfLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-218002',
    language: Language.FR,
    subject: "Mise à jour d'une charge exceptionnelle ou d'un service",
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Une charge exceptionnelle ou un service a été mis à jour.</p>
          <p>Plus de détails ici: {{pdfLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-218003',
    language: Language.NL,
    subject: 'Uitzonderlijke last of dienst update',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Een uitzonderlijke last of dienst is bijgewerkt.</p>
          <p>Alle details hier: {{pdfLink}}.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-218004',
    language: Language.DE,
    subject: 'Aktualisierung außergewöhnlicher Belastungen oder Leistungen',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Eine außergewöhnliche Belastung oder Leistung wurde aktualisiert.</p>
          <p>Weitere Details hier: {{pdfLink}}.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
